import moment from 'moment';

const initialState = {
  reports: {},
  userReports: [],
  dealersReports: [],
  jobReports: [],
  dateForReports: {
    startDateReport: moment(),
    endDateReport: moment()
  }
}

export const reportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_REPORTS':
      return {
        ...state,
        reports: action.payload,
      }
    case 'FETCH_REPORTS_USERS':
      return {
        ...state,
        jobReports: [ action.payload ],
      }
    case 'FETCH_REPORTS_DEALERS':
      return {
        ...state,
        jobReports: [ action.payload ],
      }
    case 'FETCH_REPORTS_JOB':
      return {
        ...state,
        jobReports: [ action.payload ],
      }
    case 'SET_DATE_FOR_REPORTS':
      return  {
      ...state,
        dateForReports: {
          ...action.payload
        }
      }
    default:
      return state
  }
}
